import { h } from "omi";

export function CountryZAIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
      <g clip-path="url(#a)">
        <path
          d="M10 20c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C4.4771 0 0 4.4771 0 10c0 5.5228 4.4771 10 10 10Z"
          fill="#F0F0F0"
        />
        <path
          d="M2.9284 17.0711c-3.9052-3.9052-3.9052-10.2369 0-14.1421C2.9282 2.9294 8.6952 10 8.6952 10l-5.7668 7.0711Z"
          fill="#000"
        />
        <path
          d="m8.6959 10.0002-7.3694-4.98A9.9661 9.9661 0 0 0 .7234 6.261l3.7308 3.7393-3.7307 3.7394c.173.4288.3743.843.6026 1.2399l7.3697-4.9794Z"
          fill="#FFDA44"
        />
        <path
          d="M19.9154 8.6956h-11.22L2.929 2.929A10.0383 10.0383 0 0 0 1.3263 5.02l4.9703 4.9799-4.9707 4.9793c.4413.767.9814 1.47 1.603 2.0916l5.7665-5.7666h11.22a10.0948 10.0948 0 0 0 0-2.6086Z"
          fill="#6DA544"
        />
        <path
          d="M3.9114 17.9317c1.6863 1.2961 3.797 2.0673 6.0883 2.0673 4.6203 0 8.508-3.1337 9.6555-7.3913H9.2354l-5.324 5.324Z"
          fill="#0052B4"
        />
        <path
          d="M19.6552 7.3906C18.5077 3.1329 14.62-.0007 9.9997-.0007c-2.2912 0-4.402.7711-6.0883 2.0673l5.324 5.324h10.4198Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
